import { PCImage } from 'app/design/primitives/image';
import React from 'react';
import { StyleSheet, View, type ImageSourcePropType } from 'react-native';
import Animated, { Easing, useAnimatedStyle, useSharedValue, withRepeat, withTiming } from 'react-native-reanimated';

interface LoadingAvatarProps {
  uri: string | number | undefined;
}

export function LoadingAvatar({ uri }: LoadingAvatarProps) {
  const rotation = useSharedValue(0);

  React.useEffect(() => {
    rotation.value = withRepeat(withTiming(360, { duration: 4000, easing: Easing.linear }), -1);
  }, [rotation]);

  const animatedStyle = useAnimatedStyle(() => ({
    transform: [{ rotate: `${String(rotation.value)}deg` }],
  }));

  const imageSource: ImageSourcePropType | undefined =
    uri === undefined ? undefined : typeof uri === 'string' ? { uri } : uri;

  return (
    <View style={loadingStyles.container}>
      <PCImage source={imageSource} style={loadingStyles.avatar} />
      <Animated.View style={[loadingStyles.circle, animatedStyle]}>
        <View style={loadingStyles.icon} />
        <View style={[loadingStyles.icon, { bottom: -13, top: undefined }]} />
      </Animated.View>
    </View>
  );
}

const CIRCLE_SIZE = 120;
const AVATAR_SIZE = 80;

const loadingStyles = StyleSheet.create({
  container: {
    width: CIRCLE_SIZE,
    height: CIRCLE_SIZE,
    justifyContent: 'center',
    alignItems: 'center',
  },
  avatar: {
    width: AVATAR_SIZE,
    height: AVATAR_SIZE,
    borderRadius: AVATAR_SIZE / 2,
    position: 'absolute',
  },
  circle: {
    width: CIRCLE_SIZE,
    height: CIRCLE_SIZE,
    borderRadius: CIRCLE_SIZE / 2,
    borderWidth: 4,
    borderColor: 'white',
    justifyContent: 'flex-start',
    alignItems: 'center',
    position: 'absolute',
  },
  icon: {
    width: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: 'white',
    position: 'absolute',
    top: -13,
  },
});
